import styled from 'styled-components';

export const DrivesContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: auto;
`;

export const FiltersRow = styled.div`
  height: 80px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ContentArea = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  background: #ffffff;
`;


export const CardViewXContainer = styled.div`
  display: grid;
  gap: 16px;
  width: 100%;

  /* 2 columns for small screens (S) */
  grid-template-columns: repeat(2, 1fr);

  /* 4 columns for medium and large screens (M and L) */
  @media (min-width: 1440px) {
    grid-template-columns: repeat(3, 1fr);
  }

  /* 5 columns for extra large screens (XL) */
  @media (min-width: 1920px) {
    grid-template-columns: repeat(5, 1fr);
  }
`;

export const LoadMoreContainer = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  margin: 16px 0 24px;
`;

export const DriveCardContainer = styled.div`
    & > div {
      cursor: pointer;
    }

    & > div > div:nth-child(2) > div > span {
      display: inline;
      white-space: nowrap;
    }

    & > div > div > div > div:nth-child(2) > div.dots-menu > button{
        padding: 0 8px;
    }
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 400px;
`;